import React from "react";

//SBOMCISO
const RequestsByApplicationSBOM = React.lazy(() =>
  import("../RequestsByApplicationSBOM.js")
);

const RequestStatusSBOM = React.lazy(() => import("../RequestStatusSBOM.js"));

const VulByActionPlanSBOM = React.lazy(() =>
  import("../VulByActionPlanSBOM.js")
);

const CisoSBOMtable = React.lazy(() => import("../CisoSBOMtable.js"));

export const CISOSBOMContainers1 = [
  {
    key: 1,
    title: `Requests By Application`,
    chart: (props) => <RequestsByApplicationSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-4 col-lg-4 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Requests By Application</h4>
      </div>
    ),
  },
  {
    key: 2,
    title: `Request Status`,
    chart: (props) => <RequestStatusSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-4 col-lg-4 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Request Status</h4>
      </div>
    ),
  },
  {
    key: 3,
    title: `Vulnerabilities By Action Plan`,
    chart: (props) => <VulByActionPlanSBOM {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "ccol-xl-4 col-lg-4 col-md-12 filtercol",
    customHeader: () => (
      <div className="fltrhead">
        <h4>Vulnerabilities By Action Plan</h4>
      </div>
    ),
  },
  {
    key: 4,
    title: `Details`,
    chart: (props) => <CisoSBOMtable {...props} />,
    navContainerClass: "flowdisnav",
    customClass: "col-xl-12 col-lg-12 col-md-12 filtercol",
  },
];
